import { withPopover } from '@vlabs/monokit/shared/ui/popovers/withPopover';
import { SideMenuFilterItem } from '@vlabs/monokit/shared/ui/side-menu-filter-item';

// eslint-disable-next-line import-x/no-namespace
import * as Popovers from './popovers';

const withRightPopover = withPopover({ placement: 'right' });
const withSideMenuItemRightPopover = withRightPopover(SideMenuFilterItem);

export const AgeFilterWithRightPopover = withSideMenuItemRightPopover(
  Popovers.AgeFilterPopover,
);
export const ApparentAgeFilterWithRightPopover = withSideMenuItemRightPopover(
  Popovers.ApparentAgeFilterPopover,
);
export const ApparentGenderFilterWithRightPopover = withSideMenuItemRightPopover(
  Popovers.ApparentGenderFilterPopover,
);
export const BackpackFilterWithRightPopover = withSideMenuItemRightPopover(
  Popovers.BackpackFilterPopover,
);
export const FacecoverScoreFilterWithRightPopover = withSideMenuItemRightPopover(
  Popovers.FacecoverScoreFilterPopover,
);
export const GenderFilterWithRightPopover = withSideMenuItemRightPopover(
  Popovers.GenderFilterPopover,
);
export const GeolocationFilterWithRightPopover = withSideMenuItemRightPopover(
  Popovers.GeolocationFilterPopover,
);
export const HeadwearFilterWithRightPopover = withSideMenuItemRightPopover(
  Popovers.HeadwearFilterPopover,
);
export const HandlersFilterWithRightPopover = withSideMenuItemRightPopover(
  Popovers.HandlersFilterPopover,
);
export const ListsFilterWithRightPopover = withSideMenuItemRightPopover(
  Popovers.ListsFilterPopover,
);
export const LowerFilterWithRightPopover = withSideMenuItemRightPopover(
  Popovers.LowerFilterPopover,
);
export const SimilarityFilterWithRightPopover = withSideMenuItemRightPopover(
  Popovers.SimilarityFilterPopover,
);
export const ShoesFilterWithRightPopover = withSideMenuItemRightPopover(
  Popovers.ShoesFilterPopover,
);
export const SourcesFilterWithRightPopover = withSideMenuItemRightPopover(
  Popovers.SourcesFilterPopover,
);
export const UpperFilterWithRightPopover = withSideMenuItemRightPopover(
  Popovers.UpperFilterPopover,
);
export const VideoAnalyticsStreamsFilterWithRightPopover = withSideMenuItemRightPopover(
  Popovers.VideoAnalyticsStreamsFilterPopover,
);
export const VideoAnalyticsScoreFilterWithRightPopover = withSideMenuItemRightPopover(
  Popovers.VideoAnalyticsScoreFilterPopover,
);
